'use client';

import {
  Button,
  FormControl,
  FormLabel,
  Stack,
  TextField,
} from '@mui/material';

import type { StepProps } from '@/components/wizard/StepProps';
import { validateName } from '@/components/wizard/renameEntityName';

import type { ZeroEtlPolicyEditState } from './ZeroEtlPolicyCreationFlow';

export const ZeroEtlPolicyNameSelection = (
  props: StepProps<ZeroEtlPolicyEditState>
) => {
  const next = () => {
    props.setNextStep(props.currentStep.next?.[0]);
  };

  return (
    <Stack sx={{ height: '100%' }} alignItems='center' justifyContent='center'>
      <Stack width='400px' gap='40px'>
        <Stack gap='16px'>
          <FormControl size='small' sx={{ flex: 1 }}>
            <FormLabel>Name</FormLabel>
            <TextField
              slotProps={{
                htmlInput: {
                  'data-testid': 'create-zero-etl-policy-name-input',
                },
              }}
              autoFocus
              sx={{ '& .MuiOutlinedInput-root': { padding: '8px' } }}
              placeholder='Use a descriptive name, such as "Production DBs"'
              onChange={(e) =>
                props.setWizardState({
                  ...props.wizardState,
                  name: e.target.value,
                })
              }
              value={props.wizardState.name}
            />
          </FormControl>
        </Stack>
        <Button
          data-testid='create-zero-etl-policy-name-continue-btn'
          variant='contained'
          disabled={!validateName(props.wizardState.name)}
          onClick={next}
          sx={{ height: '48px' }}
        >
          Continue
          <i className='material-symbols-arrow-right-alt ml-[8px]' />
        </Button>
      </Stack>
    </Stack>
  );
};
